import * as React from 'react';

import type { BillableWorkDefinitionFieldRM, BillableWorkRM } from 'ab-requestModels/reportType/reportType.requestModel';

import { useToggle } from 'af-utils/react.util';

import BillableWorkFieldList from './BillableWorkFieldList';
import BillingTypeInfo from './BillingTypeInfo';
import styles from './styles.module.scss';
import type { ReportBlockFieldFormModel } from '../../../../Shared/formModel';

interface Props {
	billableWork: BillableWorkRM;
	index: number;
	onDelete: (index: number) => void;
	onEdit: (index: number) => void;
	definitionFields: BillableWorkDefinitionFieldRM[];
	reportFieldsByIdMap: Record<string, ReportBlockFieldFormModel>;
}

const BillableWorkListItem: React.FC<Props> = (props) => {
	const {
		billableWork,
		index,
		onDelete,
		onEdit,
		reportFieldsByIdMap,
	} = props;
	const { workName } = billableWork;

	const {
		value: isExpanded,
		setToTrue: expand,
		setToFalse: shrink,
	} = useToggle(false);

	const handleDelete = React.useCallback(() => {
		onDelete(index);
	}, [index, onDelete]);

	const handleEdit = React.useCallback(() => {
		onEdit(index);
	}, [index, onEdit]);

	const expandIconName = `${styles.expander} ${isExpanded ? 'icon-up' : 'icon-down'}`;

	return (
		<div className={styles.BillableWorkListItem}>
			<div className={styles.content}>
				<div className={styles.titleContainer} onClick={isExpanded ? shrink : expand}>
					<span className={expandIconName} />
					<div className={styles.workName}>{workName}</div>
				</div>
				<BillingTypeInfo billableWork={billableWork} />
				{isExpanded && (
					<BillableWorkFieldList billableWork={billableWork} reportFieldsByIdMap={reportFieldsByIdMap} />
				)}
			</div>
			<div className={styles.actions}>
				<span
					className={`${styles.action} ${styles.edit} icon icon-edit`}
					onClick={handleEdit}
				/>
				<span
					className={`${styles.action} ${styles.delete} icon icon-delete`}
					onClick={handleDelete}
				/>
			</div>
		</div>
	);
};

export default React.memo(BillableWorkListItem);
